import { DangerousTranslate } from '~/components/DangerousTranslate'
import { GT } from '~/lib/gt'

const marketingConsent = (gt: GT) => ({
  label: (
    <DangerousTranslate
      text={gt.tp(
        'RegisterForm',
        '{{ thankYouBold }} - I would like to use discount codes, receive notifications about RestaurantWeek®, FineDiningWeek® and other Festivals, and receive the eBook "BEST RESTAURANT PROVISIONS" as a gift {{ valuedAtBold }}, in connection with which I agree to send commercial information (e-mail/SMS)',
        {
          thankYouBold: `<b>${gt.tp('RegisterForm', 'Yes, thank you')}</b>`,
          valuedAtBold: `<b>${gt.tp('RegisterForm', '(valued at PLN 78)')}</b>`,
        }
      )}
    />
  ),
  showMore: (
    <DangerousTranslate
      text={gt.tp(
        'RegisterForm',
        'by RestaurantWeek Sp. z o.o. and I acknowledge that I am 18 years of age or older and agree to receive content related to festival partners, including content related to alcohol brands (e.g., information about the event sponsor or the cocktail served at the dinner).'
      )}
    />
  ),
})

export const getCopy = (gt: GT) => ({
  marketingConsent: marketingConsent(gt),
})
